import * as tslib_1 from "tslib";
// Core packages
import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
// Custom packages
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from "src/app/shared/services/helper.service";
var ExportCdDocsDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ExportCdDocsDialogComponent(dialogRef, data, configService, cookieService, translateService, propertiesService, helperService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.propertiesService = propertiesService;
        this.helperService = helperService;
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.subscriptions = [];
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.send'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paper-plane',
                inline: true,
            },
        };
        // END - Add communication form
        this.dialogIsLoading = true;
    }
    /**
     * Init component
     *
     */
    ExportCdDocsDialogComponent.prototype.ngOnInit = function () {
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        this.onExportFile(this.data.propertyId, this.data.propertyName);
    };
    /**
     * CD Export file
     * export the files of all condominium documents in zip format
     *
     * @since 1.0.0
     */
    ExportCdDocsDialogComponent.prototype.onExportFile = function (propertyId, propertyName) {
        var _this = this;
        this.subscriptions.push(this.propertiesService.getFileExport(propertyId).subscribe(function (res) {
            var e_1, _a;
            var fileBlob = res;
            _this.dialogIsLoading = false;
            if (fileBlob.status) {
                var documents = [];
                if (fileBlob.listZipFiles && Array.isArray(fileBlob.listZipFiles)) {
                    try {
                        for (var _b = tslib_1.__values(fileBlob.listZipFiles), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var file = _c.value;
                            documents.push({
                                filename: file.fileName,
                                originalName: file.fileName,
                                path: file.pathFileName,
                                size: file.fileSize,
                                mimetype: fileBlob.fileMimeType,
                            });
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                _this.model = {
                    documents: documents,
                };
                _this.initForm();
            }
        }, function (err) {
            _this.dialogIsLoading = false;
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    ExportCdDocsDialogComponent.prototype.initForm = function () {
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        className: "col-12 mb-0",
                        type: "file-downloader",
                        key: "documents",
                        hideExpression: function (model) { return !model || model.length === 0; },
                        templateOptions: {
                            label: this.translateService.instant('properties.fields.documents'),
                            required: false,
                            bindLabel: "originalName",
                            readonly: true,
                        }
                    },
                ],
            },
        ];
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     */
    ExportCdDocsDialogComponent.prototype.onClose = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.dialogRef.close();
    };
    return ExportCdDocsDialogComponent;
}());
export { ExportCdDocsDialogComponent };
